import React, { useEffect, useState, useContext } from "react";
import { Typography, Box, Backdrop, CircularProgress, InputAdornment, TextField, Button, Stack, TableCell, DialogContent, IconButton, Dialog} from "@mui/material";
import { Search, InfoOutlined, InsertDriveFileOutlined } from '@mui/icons-material';
import SorTable from "./sortable";
import { API } from "../conf";
import { Context } from "../App";
import moment from 'moment';
import {theme} from '../App'

export default function CompteHistory(props) {
    const { updateConnect } = useContext(Context)
    const editCol = {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'80px', maxWidth:'120px'}} >
        <IconButton aria-label="informations complémentaires" onClick={()=>get_facture(row)}><InfoOutlined fontSize="small"/></IconButton>
    </TableCell>}
    const table = [
        {header: "Date", sortable: true, sortBy:(el)=>new Date(el.date).getTime(), row: (row, index)=><TableCell key={index} align="center" >{moment.utc(row.date).format('DD/MM/YYYY')}</TableCell>},
        {header: "Libellé", sortable: true, sortBy:el=>el.libelle.toLowerCase(), row: (row, index)=><TableCell key={index} sx={{minWidth:'150px', width:'100%'}} align="center">{row.libelle}</TableCell>},
        {header: "Montant", sortable: true, sortBy:el=>el.montant, row: (row, index)=><TableCell key={index} align="right" style={{fontWeight:'bold', color: row.montant>0? row.is_verse ? theme.palette.valide.main : '#828282' : theme.palette.carmine.main}}>{(row.montant>0?'+':'')+row.montant?.toFixed(2)}€</TableCell>},
    ]
    const [loading, setLoad] = useState(true)
    const [min_date, setMin] = useState()
    const [start_date, setStart] = useState(props.start_date??'')
    const [end_date, setEnd] = useState(props.end_date??'')
    const [search_input, setSearch] = useState('')
    const [history, setHistory] = useState()
    const [pdf, setPdf] = useState()
    const [showPdf, setShow] = useState(false)

    function get_facture(log) {
        setLoad(true)
        fetch(API.concat(`/eglises/by/${JSON.stringify({isFederation: true})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setPdf(URL.createObjectURL(json))
                    setShow(true);
                }
                setLoad(false)
            }
        })
    }

    async function get_history() {
        setLoad(true)
        const eglise = JSON.parse(sessionStorage.getItem('eglise'))
        const end = new Date(new Date(end_date).setDate(new Date(end_date).getDate()+1))
        const start = new Date(start_date)

        function get_dons(end, start) { return new Promise((resolve, reject) => {
            let request_params;
            if (props.compte.is_offrande&&(props.compte.is_hors_budget||props.compte.percent<=0)) {
                request_params = {is_hors_budget: true, eglise: eglise.number, end: end, start: start, compte: props.compte.num}
            } else {
                request_params = {is_hors_budget: false, eglise: eglise.number, end: end, start: start, compte: props.compte.num, percent: props.compte.percent}
            }
            fetch(API.concat(`/dons/compte/${JSON.stringify(request_params)}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async res=>{
                const token = res.headers.get('x-auth-token')
                if(res.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', res.headers.get('x-auth-token'))
                    }
                    if (res.status === 200) {
                        const json = await res.json()
                        const dons = json.map(item => { 
                            item.libelle = item.is_verse ? 'don' : 'à venir'
                            item.montant = item.total
                            return item
                        }).filter(i=>i.montant>0)
                        resolve(dons)
                    } else resolve([])
                }
            })
        })}

        function get_depenses(end, start) { return new Promise((resolve, reject) => {
            fetch(API.concat(`/depenses/by/${JSON.stringify({eglise: eglise.number, compte: props.compte.num, $and: [{date: {$lte: end}}, { date: {$gte:start}}]})}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        const deps = json.map(item => { return({date: item.date, libelle: item.libelle, montant: -item.montant})})
                        resolve(deps)
                    } else resolve([])
                }
            })
        })}
        
        const dons = await get_dons(end, start)
        const depenses = await get_depenses(end, start)
        const sorted = dons.concat(depenses).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
        setHistory(sorted); setLoad(false)
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-,.€]/gi,'').toLowerCase()
    }

    function get_searchable(row) {
        return row.libelle+' '+row.montant?.toFixed(2)
    }

    useEffect(()=>{
        const eglise = JSON.parse(sessionStorage.getItem('eglise'))

        function get_dates() {
            fetch(API.concat(`/depenses/${eglise.number}/dates/min_max`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    const depenses = response.status===200 ? await response.json() : []
                    fetch(API.concat(`/dons/${eglise.number}/dates/min_max`), {
                        method:'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                        }
                    }).then(async res=>{
                        const token = res.headers.get('x-auth-token')
                        if(res.status === 401) {
                            sessionStorage.clear()
                            updateConnect(false)
                        }else {
                            if (token && token !== sessionStorage.getItem('token') && token !== '') {
                                sessionStorage.setItem('token', res.headers.get('x-auth-token'))
                            }
                            if (res.status === 200) {
                                const dons = await res.json()
                                const max = dons?.maxdate&&moment.utc(dons?.maxdate).isAfter(moment.utc(depenses?.maxdate))?dons.maxdate : depenses?.maxdate?depenses.maxdate:new Date(dons?.maxdate??'')
                                setMin(depenses?.mindate&&moment.utc(depenses.mindate).isBefore(moment.utc(dons?.mindate))?depenses.mindate : dons?.mindate?dons.mindate:new Date().setDate(0))
                                if(end_date==='')setEnd(moment(max).format('yyyy-MM-DD'))                                  
                            }
                        }
                    })
                }
            })
        }
        get_dates()

        if (start_date!=='' && end_date!=='') {
            get_history()
        }
    }, [updateConnect])   
    
    return(
        <Box style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Historique de compte</Typography>
            <Box sx={{paddingX:'20px', marginTop:'30px'}}>
                <Box sx={{display:'flex', justifyContent:'space-between'}}>
                    <Stack direction='row' spacing={1} sx={{alignItems:'center', marginRight:5}}>
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'100px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de début"
                        type='date'
                        value={start_date}
                        inputProps={min_date&&{min: new Date(min_date).toISOString().split("T")[0], max: new Date(moment().format('yyyy-MM-DD')).toISOString().split("T")[0]}}
                        onChange={(event)=> {
                            setStart(event.target.value)
                            if (end_date!=='' && (new Date(end_date).getTime() - new Date(event.target.value).getTime()) <= 0) {
                                setEnd('')
                            } 
                        }}
                        />
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'100px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de fin"
                        type="date"
                        value={end_date}
                        inputProps={min_date&&{min: new Date(start_date!=='' ? start_date : min_date).toISOString().split("T")[0], max: new Date(moment().format('yyyy-MM-DD')).toISOString().split("T")[0]}}
                        onChange={(event)=> {
                            setEnd(event.target.value)
                            if (start_date!=='' && (new Date(event.target.value).getTime() - new Date(start_date).getTime()) <= 0) {
                                setStart('')
                            }
                        }}
                        />
                        <Button variant="contained" disabled={start_date===''||end_date===''} onClick={get_history}>Appliquer</Button>
                    </Stack>

                    <TextField
                    size="small"
                    label="Rechercher une dépense ou un don par libellé ou montant"
                    disabled={!history?.length>0}
                    sx={{width:'60%', minWidth:'300px'}}
                    style={{ alignSelf:'center'}}
                    value={search_input}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                            <Search />
                            </InputAdornment>
                        ),
                    }}
                    onChange={(event)=> setSearch(event.target.value)}
                    />
                </Box>
                
                {history && !loading && <SorTable data={history.filter(row=> normalize(get_searchable(row)).includes(normalize(search_input)))} table={table} rowsPerPage={50} rowsPerPageOptions={[10, 25, 50, 100, 300]}/>}
            </Box>

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>
            <Dialog open={showPdf} onClose={()=>setShow(false)} fullWidth>
                <DialogContent>
                    {pdf && <embed src={pdf} width='100%' height='400px' type="application/pdf" />}
                </DialogContent>
            </Dialog>
        </Box>
    )
}